<p-dialog
  [draggable]="false"
  header="Portfolio Company Status"
  class="responsive-dialog"
  [(visible)]="_isVisible"
  [modal]="true"
  (onHide)="onHide()"
>
  <div *ngIf="isShowFilter" class="toggle-switch" style="text-align: right; margin-bottom: 1rem;">
    <app-qep-toggle
      toggleLabel="Show All"
      [isChecked]="showExitedTasks"
      (valueChanged)="updateVisibleTasks($event)">
    </app-qep-toggle>
  </div>

  <p-table #taskTable class="table" [value]="visibleTasks" sortMode="single"
    [customSort]="true"
    (sortFunction)="customColumnSort($event)">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="fundFamily" scope="col">Fund Name <p-sortIcon field="fundFamily"></p-sortIcon></th>
        <th pSortableColumn="mnemonic" scope="col">Mnemonic <p-sortIcon field="mnemonic"></p-sortIcon></th>
        <th pSortableColumn="company" scope="col">Company <p-sortIcon field="company"></p-sortIcon></th>
        <th pSortableColumn="stage" scope="col">Stage <p-sortIcon field="stage"></p-sortIcon></th>
        <th scope="col" *ngIf="showActivityTask">Activity</th>
        <th pSortableColumn="valuationApprovalStage" *ngIf="showValuationTask" scope="col">Valuation Stage <p-sortIcon field="valuationApprovalStage"></p-sortIcon></th>
        <th pSortableColumn="valuationWriteupStage" *ngIf="showWriteUpTask" scope="col">Valuation WriteUp <p-sortIcon field="valuationWriteupStage"></p-sortIcon></th>
        <th pSortableColumn="tearsheetApprovalStage" *ngIf="showTearsheetTask" scope="col">Tearsheet Stage <p-sortIcon field="tearsheetApprovalStage"></p-sortIcon></th>
        <th pSortableColumn="financialApprovalStage" *ngIf="showFinancialApprovalTask" scope="col">Financials Status <p-sortIcon field="financialApprovalStage"></p-sortIcon></th>
        <th pSortableColumn="boardBookApprovalStage" *ngIf="showBoardBookApprovalTask" scope="col">Board Book Status <p-sortIcon field="boardBookApprovalStage"></p-sortIcon></th>
        <th pSortableColumn="isCreated" scope="col" *ngIf="showStatusTask">Status <p-sortIcon field="isCreated"></p-sortIcon></th>
        <th pSortableColumn="completionDate" scope="col">Completion Date <p-sortIcon field="completionDate"></p-sortIcon></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-task>
      <tr
        class="task-item"
        style="cursor: pointer;"
        tabindex="0"
        (click)="redirectToTask(task)"
        (keydown.enter)="redirectToTask(task)"
        [ngClass]="{
          'task-complete': (task.isCreated && !isNonActiveStage(task.stage, task.mnemonic)) || (task.isCreated && showBoardBookApprovalTask && showFinancialApprovalTask),
          'task-incomplete': (!task.isCreated && !isNonActiveStage(task.stage, task.mnemonic)) || (!task.isCreated && showBoardBookApprovalTask && showFinancialApprovalTask),
          'exited-pc': isNonActiveStage(task.stage, task.mnemonic),
          'task-carried-forward': task.approvalStage === 'carried-forward-file' && !isNonActiveStage(task.stage, task.mnemonic)
        }"
        tooltipPosition="bottom"
        [pTooltip]="getRowTooltip(task)"
      >
        <td>
          {{ task.fundFamily?.join(', ') || '-' }}
        </td>
        <td tooltipPosition="top">
          {{ task.mnemonic }}
        </td>
        <td tooltipPosition="top">
          {{ task.company }}
        </td>
        <td tooltipPosition="top">
          {{ task.stage }}
        </td>
        <td *ngIf="showActivityTask"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ task.activity }}
        </td>
        <td *ngIf="showValuationTask"
          style="white-space: nowrap;"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ isNonActiveStage(task.stage, task.mnemonic) ? 'N/A' : task.valuationApprovalStage }}
          <i
            *ngIf="task.valuationUpdatedBy && !isNonActiveStage(task.stage, task.mnemonic)"
            class="pi pi-user ml-1 cursor-pointer"
            pTooltip="{{ task.valuationUpdatedBy }}"
            tooltipPosition="top"
          ></i>
        </td>

        <td
          *ngIf="showWriteUpTask"
          style="white-space: nowrap;"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ isNonActiveStage(task.stage, task.mnemonic) ? 'N/A' : task.valuationWriteupStage }}
          <i
            *ngIf="task.valuationUpdatedBy && !isNonActiveStage(task.stage, task.mnemonic)"
            class="pi pi-user ml-1 cursor-pointer"
            pTooltip="{{ task.valuationUpdatedBy }}"
            tooltipPosition="top"
          ></i>
        </td>

        <td
          *ngIf="showTearsheetTask"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ isNonActiveStage(task.stage, task.mnemonic) ? 'N/A' : task.tearsheetApprovalStage }}
          <i
            *ngIf="task.tearsheetUpdatedBy && (task.tearsheetUpdatedBy !== 'N/A' && task.tearsheetUpdatedBy !== 'NA') && !isNonActiveStage(task.stage, task.mnemonic)"
            class="pi pi-user ml-1 cursor-pointer"
            pTooltip="{{ task.tearsheetUpdatedBy }}"
            tooltipPosition="top"
          ></i>
        </td>

        <td *ngIf="showFinancialApprovalTask"
          [ngClass]="{
            'task-complete': task.financialApprovalStage == 'Uploaded' && !isNonActiveStage(task.stage, task.mnemonic),
            'task-incomplete': task.financialApprovalStage == 'Pending' && !isNonActiveStage(task.stage, task.mnemonic),
            'exited-pc': isNonActiveStage(task.stage, task.mnemonic)
          }"
          style="white-space: nowrap;"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ task.financialApprovalStage }}
        </td>

        <td *ngIf="showBoardBookApprovalTask"
          [ngClass]="{
            'task-complete': task.boardBookApprovalStage == 'Uploaded' && !isNonActiveStage(task.stage, task.mnemonic),
            'task-incomplete': task.boardBookApprovalStage == 'Pending' && !isNonActiveStage(task.stage, task.mnemonic),
            'exited-pc': isNonActiveStage(task.stage, task.mnemonic)
          }"
          style="white-space: nowrap;"
          [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'"
        >
          {{ task.boardBookApprovalStage }}
        </td>

        <td *ngIf="showStatusTask" [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'">
          {{ isNonActiveStage(task.stage, task.mnemonic) ? task.stage : (task.isCreated ? 'Complete' : 'Incomplete') }}
        </td>

        <td [style.color]="isNonActiveStage(task.stage, task.mnemonic) ? '#999' : 'inherit'">
          <ng-container *ngIf="showBoardBookApprovalTask; else otherCompletionDate">
            <div *ngIf="task.financialStatementUpdatedAt">
              Financials: {{ task.financialStatementUpdatedAt | date : 'shortDate' }}
            </div>
            <div *ngIf="task.boardMeetingUpdatedAt">
              Board Book: {{ task.boardMeetingUpdatedAt | date : 'shortDate' }}
            </div>
          </ng-container>
          <ng-template #otherCompletionDate>
            {{ isNonActiveStage(task.stage, task.mnemonic) ? '-' : (task.isCreated ? (task.completionDate | date : 'shortDate') : '-') }}
          </ng-template>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="completion-count" style="margin-top: 1rem;">
    Progress:
    <span class="completion-count-pending">{{ taskDialogCompleteCount }}</span> of
    {{ totalVisibleTasksCount }} tasks completed
  </div>
</p-dialog>
